<template>
  <Model>
    <div v-if="!request" style="height: 200px">
      <div class="flex items-center justify-center">
        <h1>Loading..</h1>
      </div>
    </div>
    <div class="body" v-if="request">
      <div class="bg-purple-blue">
        <div class="px-3 py-2">
          <h2 class="text-xl text-white font-bold">Request</h2>
        </div>
      </div>
      <div class="overflow-y-auto no-scrollbar max-h-96">
        <!-- Top Sectionn -->
        <div class="md:grid md:grid-cols-4 md:gap-6">
          <div class="md:col-span-2">
            <div class="px-4 py-5">
              <div class="grid grid-cols-4 gap-1">
                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Request ID(Auto)</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.id"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Date</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.date"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Time</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.time"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Salesperson</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.salesperson"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Location</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.location"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >Region</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.region"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>

                <div
                  class="col-span-4 sm:col-span-1 md:flex md:items-center md:justify-center"
                >
                  <div class="bg-indigo-100 rounded shadow w-full">
                    <div class="px-3 py-2">
                      <label
                        for="customername"
                        class="text-gray-700 font-medium block text-sm"
                        >City</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-span-4 sm:col-span-3">
                  <input
                    disabled
                    type="text"
                    :value="request.city"
                    class="block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2"></div>
        </div>

        <!--Bottom Section -->
        <div class="md:grid md:grid-cols-4 md:gap-6">
          <div class="md:col-span-2">
            <div class="px-4 py-5">
              <div
                class="grid grid-flow-row grid-cols-2 grid-rows-1 data-table"
              >
                <input
                  disabled
                  type="text"
                  :value="SKU"
                  class="focus:ring-indigo-500 text-gray-700 font-bold focus:border-indigo-500 block w-full sm:text-sm border-gray-300 border-r-0 bg-indigo-100"
                />
                <input
                  disabled
                  type="text"
                  :value="Quntity"
                  class="focus:ring-indigo-500 text-gray-700 font-bold focus:border-indigo-500 block w-full sm:text-sm border-gray-300 bg-indigo-100"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku1">{{ request.sku1 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty1"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku2">{{ request.sku2 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty2"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku3">{{ request.sku3 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty3"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku4">{{ request.sku4 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty4"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku5">{{ request.sku5 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty5"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku6">{{ request.sku6 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty6"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku7">{{ request.sku7 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty7"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku8">{{ request.sku8 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty8"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku9">{{ request.sku9 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty9"
                  class="block w-full sm:text-sm border-gray-300"
                />

                <select
                  class="block w-full sm:text-sm border-gray-300 border-r-0"
                >
                  <option :value="request.sku10">{{ request.sku10 }}</option>
                </select>
                <input
                  disabled
                  type="text"
                  :value="request.qty10"
                  class="block w-full sm:text-sm border-gray-300"
                />
              </div>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2"></div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button type="button" class="submit bg-purple-blue" @click="submit">
        Receipt
      </button>
      <button type="button" class="close" @click="close" ref="cancelButtonRef">
        Cancel
      </button>
    </div>
  </Model>
</template>

<script>
import Model from "../../components/containers/model/Model-7xl.vue";
import { mapActions, mapState } from "vuex";

export default {
  props: ["id"],
  components: {
    Model,
  },
  created() {
    console.log(this.id);
    this.fetchRequest(this.id).then(() => {
      console.log("Request fetched successfully", this.request);
    });
  },
  methods: {
    submit() {
      alert("Print request will be implemented soon");
    },
    close() {
      this.$router.push({ name: "Request" });
    },
    ...mapActions("request", ["fetchRequest", "putRequest"]),
  },
  computed: {
    ...mapState(["skus"]),
    ...mapState({
      request: (state) => state.request.request,
    }),
  },
};
</script>

<style scoped>
.body {
  @apply bg-white;
}
.footer {
  @apply bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse;
}
.footer .submit {
  @apply w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm;
}
.footer .close {
  @apply mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm;
}
.input-text {
  @apply mt-1  block w-full shadow-sm sm:text-sm border-gray-300 rounded-md;
}
</style>